/**
 *  @class
 *  @function PredictiveSearch
 */
class PredictiveSearch {
  constructor() {
    this.container = document.getElementById('Search-Drawer');
    this.form = this.container.querySelector('form.searchform');
    this.button = document.querySelectorAll('.thb-quick-search');
    this.input = this.container.querySelector('input[type="search"]');
    this.defaultTab = this.container.querySelector('.side-panel-content--initial');
    this.predictiveSearchResults = this.container.querySelector('.side-panel-content--has-tabs');

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    this.button.forEach((item, i) => {
      item.addEventListener('click', (event) => {
        var _this = this;
        event.preventDefault();
        document.getElementsByTagName("body")[0].classList.toggle('open-cc');
        document.getElementsByTagName("body")[0].classList.toggle('open-search-box');
        this.container.classList.toggle('active');
        if (this.container.classList.contains('active')) {
          setTimeout(function () {
            _this.input.focus({
              preventScroll: true
            });
          }, 100);
          dispatchCustomEvent('search:open');
        }

        return false;
      });
    });
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.predictiveSearchResults.classList.remove('active');
      this.defaultTab.style.display = 'block';
      return;
    }
    this.predictiveSearchResults.classList.add('active');
    this.defaultTab.style.display = 'none';
    this.getSearchResults(searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length) {
      event.preventDefault();
    }
  }

  onFocus() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();

    this.predictiveSearchResults.classList.add('loading');

    // Tăng limit lên để đảm bảo có đủ sản phẩm sau khi filter off-seasonal.
    // Expanded match fields: default is title + product_type + variants.title + vendor.
    // We also include variants.sku (wholesale / pro buyers search by SKU)
    // and tag (matches curated taxonomy: holiday, gluten-free, gift, etc.).
    // body (description) intentionally left out — adds too much noise.
    fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,article,query,collection&${encodeURIComponent('resources[options][fields]')}=title,product_type,variants.title,vendor,variants.sku,tag&${encodeURIComponent('resources[limit]')}=20&section_id=predictive-search`)
      .then((response) => {
        this.predictiveSearchResults.classList.remove('loading');
        if (!response.ok) {
          var error = new Error(response.status);
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;

        this.renderSearchResults(resultsMarkup);
      })
      .catch(() => {
        this.predictiveSearchResults.classList.remove('loading');
        this.renderErrorMessage();
      });
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;

    let _this = this;
    
    // Setup submit button
    const submitButton = this.container.querySelector('#search-results-submit');
    if (submitButton) {
      submitButton.addEventListener('click', () => {
        _this.form.submit();
      });
    }

    // Setup suggestion links
    const suggestionLinks = this.container.querySelectorAll('.predictive-search__item.link--text');
    suggestionLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const query = e.currentTarget.textContent.trim();
        this.input.value = query;
        this.form.submit();
      });
    });

    // Setup product links để đóng search khi click
    const productLinks = this.container.querySelectorAll('.cart-product-link, .product-card-link');
    productLinks.forEach(link => {
      link.addEventListener('click', () => {
        // Delay để cho phép navigation hoàn thành
        setTimeout(() => {
          this.close();
        }, 100);
      });
    });

    // Setup collection links để đóng search khi click
    const collectionLinks = this.container.querySelectorAll('.list-item-collection a');
    collectionLinks.forEach(link => {
      link.addEventListener('click', () => {
        setTimeout(() => {
          this.close();
        }, 100);
      });
    });
  }

  renderErrorMessage() {
    this.predictiveSearchResults.innerHTML = `
      <div class="side-panel-content--box">
        <div class="side-panel-content--inner">
          <div class="side-panel-content--title">Có lỗi xảy ra</div>
          <p>Không thể tải kết quả tìm kiếm. Vui lòng thử lại.</p>
        </div>
      </div>
    `;
  }

  close() {
    this.container.classList.remove('active');
    document.getElementsByTagName("body")[0].classList.remove('open-cc');
    document.getElementsByTagName("body")[0].classList.remove('open-search-box');
    
    // Reset display states
    if (this.defaultTab) {
      this.defaultTab.style.display = 'block';
    }
    if (this.predictiveSearchResults) {
      this.predictiveSearchResults.classList.remove('active');
    }
  }
}

window.addEventListener('load', () => {
  if (typeof PredictiveSearch !== 'undefined') {
    new PredictiveSearch();
    window.__predictiveSearchReady = true;
  }
});